import { render, staticRenderFns } from "./EconomicGroupList.vue?vue&type=template&id=0f7acb46"
import script from "./EconomicGroupList.vue?vue&type=script&lang=ts"
export * from "./EconomicGroupList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports